
// UI Updates and Dom Manipulation for Subscription Funnel

window.updateUI = function () {
    try {
        console.log('=== updateUI called, currentStep:', window.currentStep);

        // 1. Hide all steps
        document.querySelectorAll('.sf-step').forEach(el => {
            el.classList.add('hidden');
            el.style.setProperty('display', 'none', 'important');
        });

        // 2. Show current step - Try ID first, then Data Attribute
        let currentEl = document.getElementById('step-' + window.currentStep);
        if (!currentEl) {
            currentEl = document.querySelector(`.sf-step[data-step="${window.currentStep}"]`);
        }

        if (currentEl) {
            console.log('--- SHOWING STEP ---', window.currentStep, currentEl);

            // Critical Fix: Ensure Step is not nested inside another step (DOM Glitch)
            const container = document.getElementById('sf-steps-container');
            if (container && currentEl.parentElement !== container) {
                console.warn('⚠️ Step was nested incorrectly! Moving to main container.', currentEl.parentElement);
                container.appendChild(currentEl);
            }

            currentEl.classList.remove('hidden');

            // Force display based on step type
            if (window.currentStep === 'plan-selection') {
                currentEl.style.setProperty('display', 'flex', 'important');
                currentEl.style.setProperty('flex-direction', 'column', 'important');
            } else {
                currentEl.style.setProperty('display', 'block', 'important');
            }

            // Ensure opacity is 1
            currentEl.style.opacity = '1';
            currentEl.style.visibility = 'visible';

        } else {
            console.error('--- STEP NOT FOUND in DOM ---', window.currentStep);
        }

        // 3. Update Progress (Dynamically calculated)
        // Avoid error if getFullStepList is not yet defined (rare but possible)
        const flow = window.getFullStepList ? window.getFullStepList() : [];
        const currentIndex = flow.indexOf(window.currentStep);
        let percent = 5;
        if (currentIndex !== -1) {
            percent = Math.max(5, Math.min(100, ((currentIndex + 1) / flow.length) * 100));
        }

        const progBar = document.getElementById('sf-progress');
        if (progBar) progBar.style.width = `${percent}%`;

        // 3.5 Update Breadcrumb Flow
        const bcFlow = document.getElementById('sf-breadcrumb-flow');
        const bcSep = document.getElementById('sf-breadcrumb-separator');
        if (bcFlow && bcSep) {
            const flowDisplay = {
                'bottled': 'Embotellada',
                'matrix': 'Embotellada'
            };
            // Show only after category selection
            const hiders = ['category-selection'];
            const shouldShowBC = !hiders.includes(window.currentStep) && window.currentFlow && flowDisplay[window.currentFlow];

            if (shouldShowBC) {
                bcFlow.innerText = flowDisplay[window.currentFlow];
                bcFlow.style.display = 'inline-block';
                bcSep.style.display = 'inline-block';
            } else {
                bcFlow.style.display = 'none';
                bcSep.style.display = 'none';
            }
        }

        // 3.6 Update Breadcrumb Product
        const bcProd = document.getElementById('sf-breadcrumb-product');
        const bcSepProd = document.getElementById('sf-breadcrumb-separator-prod');
        if (bcProd && bcSepProd) {
            const productSteps = ['product-detail', 'plan-selection', 'savings-calculator', 'elevator-check', 'pre-checkout', 'contract-data', 'validation', 'installation-schedule', 'thank-you'];
            const shouldShowProd = productSteps.includes(window.currentStep) && window.currentProductInfo && window.currentProductInfo.title;

            if (shouldShowProd) {
                bcProd.innerText = window.currentProductInfo.title;
                bcProd.style.display = 'inline-block';
                bcSepProd.style.display = 'inline-block';
            } else {
                bcProd.style.display = 'none';
                bcSepProd.style.display = 'none';
            }
        }

        // 4. Footer & Buttons
        const footerNav = document.getElementById('sf-footer-nav');
        const btnBack = document.getElementById('btn-back');
        const btnNext = document.getElementById('btn-next');

        // Default visibility
        if (footerNav) footerNav.style.display = 'flex';

        // Determine if footer should be hidden
        // Generally hidden for specific functional steps or if it is the very first step of the flow (no back)
        const alwaysHideFooter = ['validate-client', 'validation', 'installation-schedule', 'thank-you', 'quote-sent'];
        let shouldHide = alwaysHideFooter.includes(window.currentStep);

        // Special case: check-client logic removed here to allow Next button. 
        // Back button hiding is handled inside !shouldHide block below via isStart logic.
        // Special case: validate-client logic
        if (window.currentStep === 'validate-client') {
            shouldHide = true;
        }

        // EXPLICT FIX: Ensure footer is VISIBLE for these core steps
        // BUT: hide for steps where we injected local buttons to avoid duplicates
        // We moved most back to global footer, so we reduce this list.
        const stepsWithLocalNav = ['product-selection', 'product-detail'];

        // Check if we are in the elevator redirect flow (skip_check_question=true)
        // If so, we WANT the global footer and NOT the local buttons (handled in liquid/css)
        const urlParams = new URLSearchParams(window.location.search);
        const isElevatorRedirect = urlParams.get('skip_check_question');

        if (stepsWithLocalNav.includes(window.currentStep)) {
            // Force hide global footer because local one exists
            // UNLESS it is the special elevator redirect flow
            if (window.currentStep === 'product-detail' && isElevatorRedirect) {
                shouldHide = false;
            } else {
                shouldHide = true;
            }
        }

        if (footerNav) {
            if (shouldHide) {
                footerNav.style.setProperty('display', 'none', 'important');
            } else {
                footerNav.style.setProperty('display', 'flex', 'important');
                footerNav.style.setProperty('visibility', 'visible', 'important');
                footerNav.style.setProperty('opacity', '1', 'important');
                footerNav.style.setProperty('z-index', '1000', 'important');
                footerNav.style.setProperty('position', 'relative', 'important');
            }
        } else {
            console.error('--- ERROR: footerNav NOT FOUND ---');
        }

        // Custom Logic 
        if (!shouldHide) {
            // FORCE DISPLAY for plan-selection to ensure actions are visible
            if (window.currentStep === 'plan-selection') {
                if (footerNav) footerNav.style.setProperty('display', 'flex', 'important');
            }
            // Back button logic: Hide if at start of flow (urlStep) OR if it is the very first step of the calculated flow
            const isStart = (flow.indexOf(window.currentStep) === 0);
            if (btnBack) btnBack.style.display = isStart ? 'none' : 'block';
            if (btnNext) {
                btnNext.style.setProperty('display', 'inline-flex', 'important');
                btnNext.style.setProperty('opacity', '1', 'important');
                btnNext.style.setProperty('visibility', 'visible', 'important');
            }

            // Restore default navigation
            if (btnNext) btnNext.onclick = function () {
                if (window.navigate) window.navigate(1);
            }

            if (['pre-checkout', 'contract-data'].includes(window.currentStep)) {
                // Assuming these are separate snippets loaded globally or need to be moved too
                if (window.updateSummary) window.updateSummary();
                if (window.updateProductDisplay) window.updateProductDisplay();
            }

            // Handle Button Text mapping
            let btnText = 'Continuar >';

            if (window.currentFlow === 'matrix') {
                // IBBL Flow
                if (window.currentStep === 'pre-checkout') {
                    btnText = 'Pagar suscripción >';
                } else if (window.currentStep === 'elevator-check') {
                    btnText = 'Pagar >';
                } else if (window.currentStep === 'contract-data') {
                    btnText = 'Pagar ahora >';
                }
            } else {
                // Standard Flow (Bottled)
                if (window.currentStep === 'elevator-check') {
                    btnText = 'Continuar >';
                } else if (window.currentStep === 'pre-checkout') {
                    btnText = 'Tramitar pedido >';
                } else if (window.currentStep === 'contract-data') {
                    btnText = 'Pagar ahora >';
                }
            }

            if (btnNext) btnNext.innerHTML = btnText;

            // Force enable for product detail
            if (window.currentStep === 'product-detail') {
                if (window.showCorrectProduct) window.showCorrectProduct();
                if (window.enableNextStep) {
                    window.enableNextStep(true);
                    // Safety timeout
                    setTimeout(() => window.enableNextStep(true), 100);
                }
            }

            // Validation Logic per Step (Runs after force check, but product-detail is handled)
            if (window.validateCurrentStep) window.validateCurrentStep();
        }

        // --- FORCE FOOTER VISIBILITY (Safety Net) ---
        // Override any potential logic errors for these key steps
        const forceVisibleSteps = [];
        if (forceVisibleSteps.includes(window.currentStep)) {
            if (footerNav) {
                footerNav.classList.remove('hidden');
                footerNav.style.setProperty('display', 'flex', 'important');
                footerNav.style.setProperty('visibility', 'visible', 'important');
                footerNav.style.setProperty('opacity', '1', 'important');
                footerNav.style.setProperty('z-index', '9999', 'important');
                footerNav.style.setProperty('position', 'relative', 'important');
            }
            if (btnNext) {
                btnNext.style.setProperty('display', 'inline-flex', 'important');
                btnNext.style.setProperty('visibility', 'visible', 'important');
                btnNext.style.setProperty('opacity', '1', 'important');
            }
        }
    } catch (err) {
        console.error('CRITICAL ERROR IN updateUI:', err);
        // Emergency Footer Restoration
        try {
            const footerNav = document.getElementById('sf-footer-nav');
            const btnNext = document.getElementById('btn-next');
            const steps = [];

            if (steps.includes(window.currentStep)) {
                if (footerNav) {
                    footerNav.classList.remove('hidden');
                    footerNav.style.setProperty('display', 'flex', 'important');
                    footerNav.style.setProperty('visibility', 'visible', 'important');
                    footerNav.style.setProperty('opacity', '1', 'important');
                    footerNav.style.setProperty('z-index', '9999', 'important');
                    footerNav.style.setProperty('position', 'relative', 'important');
                }
                if (btnNext) {
                    btnNext.style.setProperty('display', 'inline-flex', 'important');
                    btnNext.style.setProperty('visibility', 'visible', 'important');
                    btnNext.style.setProperty('opacity', '1', 'important');
                    btnNext.onclick = function () { if (window.navigate) window.navigate(1); };
                }
                const btnBack = document.getElementById('btn-back');
                if (btnBack) {
                    btnBack.style.setProperty('display', 'block', 'important');
                    btnBack.onclick = function () { if (window.navigate) window.navigate(-1); };
                }
            }
        } catch (e2) { console.error('Double fault in updateUI:', e2); }
    }
}

window.validateCurrentStep = function () {
    const btnNext = document.getElementById('btn-next');
    if (!btnNext) return;

    let isValid = true;

    if (window.currentStep === 'category-selection') {
        const selected = document.querySelector('.sf-step[data-step="category-selection"] .sf-select-card.selected');
        isValid = !!selected;
    } else if (window.currentStep === 'plan-selection') {
        const selected = document.querySelector('.sf-step[data-step="plan-selection"] .sf-plan-card-custom.selected');
        isValid = !!selected;
    } else if (window.currentStep === 'elevator-check') {
        const selected = document.querySelector('.sf-step[data-step="elevator-check"] .sf-option-btn.selected');
        isValid = !!selected;
    } else if (window.currentStep === 'product-selection') {
        const activeContainer = document.querySelector(`.step-2-content[data-flow="${window.currentFlow}"]`);
        const selected = activeContainer ? activeContainer.querySelector('.sf-select-card.selected, .sf-product-card-horizontal.selected') : null;
        isValid = !!selected;
    } else if (window.currentStep === 'product-detail') {
        isValid = true;
    }

    if (window.enableNextStep) window.enableNextStep(isValid);
}

// Update dynamic steps
if (window.currentStep === 'product-selection') {
    if (window.showCorrectStep2Content) {
        window.showCorrectStep2Content();
    }
}
if (window.currentStep === 'product-detail' && window.showCorrectProduct) window.showCorrectProduct();

// Define function explicitly here to avoid snippet loading issues
window.showCorrectStep2Content = function () {
    console.log('=== showCorrectStep2Content EXEC (UI Script)', { flow: window.currentFlow, plan: window.selectedPlan });

    // Hide all step 2 content blocks
    const contents = document.querySelectorAll('.step-2-content');

    contents.forEach(el => { el.style.display = 'none'; });

    // Determine which content to show
    let targetSelector = '';

    if (window.selectedPlan === 'flexible') {
        // Show Bottle Quantity Calculator for Flexible Plan
        targetSelector = '.step-2-content[data-view-type="flexible"]';
    } else {
        // Show Standard Product List for other plans (Monthly)
        const targetFlow = window.currentFlow || 'bottled';
        // Try specific selector first
        targetSelector = `.step-2-content[data-view-type="standard"][data-flow="${targetFlow}"]`;

        // Verify if it exists, otherwise try broader selector
        if (!document.querySelector(targetSelector)) {
            targetSelector = `.step-2-content[data-flow="${targetFlow}"]`;
        }
    }

    const targetContent = document.querySelector(targetSelector);
    if (targetContent) {
        targetContent.style.display = 'flex';
        // Ensure local nav is visible if not flexible
        const localNav = document.getElementById('product-selection-local-nav');
        if (localNav) {
            localNav.style.display = (window.selectedPlan === 'flexible') ? 'none' : 'flex';
        }
    } else {
        console.error('No content found for selector:', targetSelector);
    }
};

// --- Client Check Logic ---
window.handleClientCheck = function (isClient, card) {
    window.isExistingClient = isClient;
    if (window.selectCard) window.selectCard(card);

    const dniSection = document.getElementById('dni-validation-section');
    const zipSection = document.getElementById('zipcode-validation-section');

    // Reset validation state on change
    window.isClientValidated = false;
    if (window.enableNextStep) window.enableNextStep(false);

    const grid = document.getElementById('client-check-main-grid');
    if (grid) grid.classList.remove('is-validated');

    if (dniSection) dniSection.style.display = isClient ? 'block' : 'none';
    if (zipSection) zipSection.style.display = !isClient ? 'block' : 'none';

    // Hide both right-side containers initially
    const welcomeMsg = document.getElementById('client-welcome-message');
    if (welcomeMsg) welcomeMsg.style.display = 'none';

    const zipcodeInfo = document.getElementById('zipcode-info-box');
    if (zipcodeInfo) zipcodeInfo.style.display = 'none';

    const zipErrorPinkBox = document.getElementById('zipcode-error-pink-box');
    if (zipErrorPinkBox) zipErrorPinkBox.style.display = 'none';

    // Trigger validation logic update
    if (window.validateCurrentStep) window.validateCurrentStep();
};

window.validateClientDNI = function () {
    const input = document.getElementById('client-dni-input');
    const msg = document.getElementById('client-welcome-message');

    if (input && input.value.trim().length > 0) {
        // Mock Validation Success for DNI
        window.isClientValidated = true;
        if (msg) msg.style.display = 'block';

        if (window.enableNextStep) window.enableNextStep(true);
        if (window.validateCurrentStep) window.validateCurrentStep();

    } else {
        alert('Por favor introduce tu DNI');
    }
};

window.checkZipInput = function (val) {
    const btn = document.getElementById('client-zipcode-submit');
    if (btn) {
        btn.disabled = val.length < 5;
        btn.style.opacity = val.length < 5 ? '0.5' : '1';
        btn.style.cursor = val.length < 5 ? 'not-allowed' : 'pointer';
    }
};

window.validateZipCode = function () {
    const input = document.getElementById('client-zipcode-input');
    const zip = input ? input.value.trim() : '';
    const searchMsg = document.getElementById('zipcode-searching-message');
    const pinkErrorBox = document.getElementById('zipcode-error-pink-box');

    if (zip.length === 5) {
        if (searchMsg) searchMsg.style.display = 'block';
        if (pinkErrorBox) pinkErrorBox.style.display = 'none';

        const baseUrl = (window.EngimatrixConfig && window.EngimatrixConfig.zipcodeUrl)
            ? window.EngimatrixConfig.zipcodeUrl
            : 'https://validate-zipcode-es-andajz4eea-ew.a.run.app';

        fetch(`${baseUrl}?zipcode=${zip}`)
            .then(res => res.json())
            .then(data => {
                if (searchMsg) searchMsg.style.display = 'none';

                // --- TRACKING: ZIP Validation Result ---
                if (window.CulliganTracking) {
                    window.CulliganTracking.track('zipcode_validation_attempt', {
                        'zipcode': zip,
                        'success': data.valid
                    });
                }

                if (data.valid) {
                    window.isClientValidated = true;
                    window.capturedZipCode = zip;
                    window.capturedRouteId = data.route_id;

                    // Reset UI: hide error side column
                    const grid = document.getElementById('client-check-main-grid');
                    if (grid) grid.classList.remove('is-validated');

                    const zipcodeInfo = document.getElementById('zipcode-info-box');
                    if (zipcodeInfo) zipcodeInfo.style.display = 'none';

                    if (window.enableNextStep) window.enableNextStep(true);
                    if (window.validateCurrentStep) window.validateCurrentStep();

                    // Auto advance to next step
                    if (window.navigate) window.navigate(1);
                } else {
                    window.isClientValidated = false;

                    // Show the information results column on error
                    const grid = document.getElementById('client-check-main-grid');
                    if (grid) grid.classList.add('is-validated');

                    const zipcodeInfo = document.getElementById('zipcode-info-box');
                    if (zipcodeInfo) zipcodeInfo.style.display = 'block';

                    const pinkErrorBox = document.getElementById('zipcode-error-pink-box');
                    if (pinkErrorBox) pinkErrorBox.style.display = 'block';

                    if (window.enableNextStep) window.enableNextStep(false);
                }
            })
            .catch(err => {
                console.error('Error validating zip code:', err);
                if (window.sfReportError) window.sfReportError(err, { failure: 'zipcode_api', zipcode: zip }, { zipcode: zip, endpoint: baseUrl });
                if (searchMsg) searchMsg.style.display = 'none';
                const isValidFallback = zip.startsWith('28') || zip.startsWith('08');

                // --- TRACKING: Fallback Result ---
                if (window.CulliganTracking) {
                    window.CulliganTracking.track('zipcode_validation_attempt', {
                        'zipcode': zip,
                        'success': isValidFallback,
                        'fallback': true
                    });
                }

                if (isValidFallback) {
                    window.isClientValidated = true;

                    // Reset UI fallback
                    const grid = document.getElementById('client-check-main-grid');
                    if (grid) grid.classList.remove('is-validated');

                    const zipcodeInfo = document.getElementById('zipcode-info-box');
                    if (zipcodeInfo) zipcodeInfo.style.display = 'none';

                    if (window.enableNextStep) window.enableNextStep(true);
                    if (window.validateCurrentStep) window.validateCurrentStep();

                    // Auto advance to next step
                    if (window.navigate) window.navigate(1);
                } else {
                    const grid = document.getElementById('client-check-main-grid');
                    if (grid) grid.classList.add('is-validated');

                    const zipcodeInfo = document.getElementById('zipcode-info-box');
                    if (zipcodeInfo) zipcodeInfo.style.display = 'block';

                    const pinkErrorBox = document.getElementById('zipcode-error-pink-box');
                    if (pinkErrorBox) pinkErrorBox.style.display = 'block';
                }
            });
    }
};
